export const organizationUserCategoryIds = raw => {
  let value = raw;
  if (typeof value === "string") { try { value = JSON.parse(value); } catch { value = value.split(","); } }
  return (Array.isArray(value) ? value : value == null ? [] : [value]).map(Number).filter(id => Number.isInteger(id) && id > 0);
};
export const organizationTaskMatchesCategories = (org, taskId, categoryIds) => {
  const rules = org.categoryRules || {};
  if (!Object.prototype.hasOwnProperty.call(rules, String(taskId))) return true;
  return Array.isArray(rules[taskId]) && rules[taskId].some(id => categoryIds.includes(Number(id)));
};

export const organizationTaskDetails = (org, tasks = [], categories = []) => (org.taskIds || []).map(taskId => {
  const task = tasks.find(row => Number(row.t_id) === Number(taskId));
  const restricted = Object.prototype.hasOwnProperty.call(org.categoryRules || {}, String(taskId));
  const categoryIds = restricted ? org.categoryRules[taskId] : [];
  return {
    taskId: Number(taskId),
    title: task?.t_title || `Task #${taskId}`,
    categoryLabel: restricted
      ? (categoryIds || []).map(id => categories.find(category => Number(category.id) === Number(id))?.name || `Category #${id}`).join(", ") || "No matching categories"
      : "Everyone in this organization",
  };
});

export const organizationHasMatchingTasks = (org, tasks, categoryIds) => (org.taskIds || []).some(taskId =>
  ![55,58].includes(Number(taskId))
  && tasks.some(task => Number(task.t_id) === Number(taskId) && Number(task.t_active ?? 1) === 1)
  && organizationTaskMatchesCategories(org, taskId, categoryIds));


export const userOrganizationSelections = (raw, fallback = []) => {
  let value=raw;
  if (typeof value === "string") {try {value=JSON.parse(value);} catch {value=[];}}
  if (value && typeof value === "object" && !Array.isArray(value)) {
    const orgIds=organizationUserCategoryIds(value.orgIds);
    return {orgIds,manualOrgIds:organizationUserCategoryIds(value.manualOrgIds).filter(id=>orgIds.includes(id))};
  }
  return {orgIds:organizationUserCategoryIds(value == null ? fallback : value),manualOrgIds:[]};
};
export const organizationTaskSelectionIds = (orgs, selectedIds, manualIds, categoryIds, tasks) => [...new Set(
  orgs.filter(org=>selectedIds.includes(Number(org.id))).flatMap(org=>(org.taskIds || []).filter(taskId=>
    ![55,58].includes(Number(taskId))
    && tasks.some(task=>Number(task.t_id)===Number(taskId)&&Number(task.t_active ?? 1)===1)
    && (manualIds.includes(Number(org.id)) || organizationTaskMatchesCategories(org,taskId,categoryIds)))).map(Number))];
